import React from 'react';
import './home.style.sass';

import StickyNav from "../../layouts/stickyNav/stickyNav.component";
import NavBar from "../../layouts/navbar/navbar.component";
import Header from "../../layouts/header/header.component";
import Footer from "../../layouts/footer/footer.component";
import HomePage from "../../layouts/homePage/homePage.component";
import {createStructuredSelector} from "reselect";
import {selectLoaded} from "../../redux/site/site.selector";
import {connect} from 'react-redux'
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";


class Home extends React.Component {
    render() {
        return (
            <div>
                {/*{loaded ? null : <Loading/>}*/}
                <TopOfNav/>
                <StickyNav/>
                {/*<TestFlag />*/}
                <NavBar/>
                <Header/>
                <HomePage/>
                <Footer/>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loaded: selectLoaded
});

export default connect(mapStateToProps)(Home);
